import { useCallback, useEffect, useRef, useState } from 'react'
import styles from './useToast.module.css'

const TOAST_DURATION_MS = 2400

export interface UseToastResult {
  toast: string | null
  show: (message: string) => void
}

/** 한 번에 메시지 하나만 들고, 2.4초 뒤 스스로 사라진다. */
export function useToast(): UseToastResult {
  const [toast, setToast] = useState<string | null>(null)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => {
    return () => {
      clearTimeout(timer.current)
    }
  }, [])

  const show = useCallback((message: string) => {
    clearTimeout(timer.current)
    setToast(message)
    timer.current = setTimeout(() => setToast(null), TOAST_DURATION_MS)
  }, [])

  return { toast, show }
}

export interface ToastProps {
  message: string
}

/**
 * 주소 복사와 계좌번호 복사 — 앱의 모든 복사 확인이 이 한 줄로만
 * 알려진다. role/aria-live가 없으면 그 피드백은 스크린리더 하객에게 존재하지 않는다.
 */
export function Toast({ message }: ToastProps) {
  return (
    <div className={styles.toast} role="status" aria-live="polite">
      {message}
    </div>
  )
}
